import { Component, Input, OnInit } from '@angular/core';
import { DateTime } from 'luxon';
import * as _ from 'lodash';

@Component({
  standalone: false,
  selector: 'app-ticket-messages',
  templateUrl: './ticket-messages.component.html',
})
export class TicketMessagesComponent implements OnInit {
  @Input() supportTicket: any;

  public loading: boolean = true;

  constructor() {}

  ngOnInit() {
    if (this.supportTicket) {
      this.supportTicket.timeAgo = DateTime.fromISO(this.supportTicket.created_at).toRelative();

      this.supportTicket.conversations.forEach((conversation) => {
        conversation.timeAgo = DateTime.fromISO(conversation.created_at).toRelative();
        conversation.authorClassName = conversation.fromSupportAgent ? 'author-machool' : 'author-user';
        conversation.cardClass = conversation.fromSupportAgent ? 'bg--accent-gray' : 'bg--light-green';
        if (conversation.private) {
          conversation.authorClassName += ' private';
          conversation.cardClass = 'bg--danger-light';
        }
      });
      this.loading = false;
    }
  }
}
